import { HttpStatus } from '../enums/http-status.enum';
import { Cause, HttpException } from './http.exception';

export class BadRequestException extends HttpException {
  constructor(cause?: Cause) {
    super('Bad Request', HttpStatus.BAD_REQUEST, cause);
  }
}
